import api from '@/api';

export type VaultResourceKind = 'troves' | 'notes' | 'highlighter';

export interface VaultListResponse {
  status: string;
  items: Record<VaultResourceKind, Array<Record<string, unknown> & { id: string }>>;
}

export async function listVaultItems(): Promise<VaultListResponse['items']> {
  const { data } = await api.get<VaultListResponse>('/vault/items');
  if (data.status !== 'success' || !data.items) throw new Error('Failed to load vault');
  return data.items;
}

export async function restoreVaultItem(kind: VaultResourceKind, id: string): Promise<void> {
  const { data } = await api.post<{ status: string }>('/vault/restore', { kind, id });
  if (data.status !== 'success') throw new Error('Restore failed');
}

export async function deleteVaultItem(kind: VaultResourceKind, id: string): Promise<void> {
  const { data } = await api.delete<{ status: string }>(`/vault/items/${kind}/${encodeURIComponent(id)}`);
  if (data.status !== 'success') throw new Error('Delete failed');
}
